import { $el } from '../elements';
import { $ui } from '../functions';
import { UIView } from '../view';

export namespace $trustly {
    interface CallbackForm {
        status: 'failure' | 'success';
        id: string;
    }

    export class Form extends UIView {
        _iframe: HTMLIFrameElement;

        constructor(payment_url: string) {
            super('div', 'ui-payment-form m-trustly');

            this.ui_add(this._iframe = $el.IFRAME(payment_url, 'r-iframe'));
        }

        wait() {
            return $ui.waitIframe<CallbackForm>(this._iframe).then(r => {
                if(r.form.status == 'success') {
                    return r.form.id;
                }

                throw 'Failed';
            });
        }
    }
}
